import {Loggedin} from '../authFilter/platformCentralAuth';
import {FeedbackType} from '../footer/footer.component';
import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';
import {ConfService} from '../conf.service';
import {Router} from '@angular/router';

declare let $;

export interface FeedbackData {
    username: string;
    partner: string;
    account: string;
    feedback_type: any;
    feedback_message: string;
    csat_score: string;

}

export interface FeedbackType {
    name: string;
    value: string;
}

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
    domainPartner: any;
    partnerLogo: any;
    brandImage: any;
    isLogo = false;
    domain: any;
    userName: string;
    feedbackSchema: any;
    feedbacktypes: FeedbackType[] = [
        {name: 'Service Issue', value: 'service'},
        {name: 'Technical Support', value: 'support'},
        {name: 'Partner Account Issue', value: 'account'},
        {name: 'Billing Issue', value: 'billing'},
        {name: 'Plans & Pricing', value: 'pricing'}
    ];

    constructor(private auth: AuthService, private router: Router, public dialog: MatDialog) {
    }

    logout() {
        this.auth.logout();
    }

    checkDomainPartner() {

        const URL = window.location.href;

        if (URL.includes('signup')) {
            this.domainPartner = null;
        } else {
            this.domainPartner = localStorage.getItem('domainPartner');
            this.partnerLogo = localStorage.getItem('logo');
            this.brandImage = localStorage.getItem('brandImage');
            if (this.partnerLogo !== null || this.partnerLogo !== '') {
                this.isLogo = true;
            }
        }
    }

    async ngOnInit() {

        await this.checkDomainPartner();

        this.userName = (localStorage.getItem('partner') ? localStorage.getItem('partner') : 'Guest');
        this.feedbackSchema = {
            username: '',
            partner: '',
            account: '',
            feedback_type: this.feedbacktypes,
            feedback_message: '',
            csat_score: 'NA'
        };
        $(document).on('click', '.dropdown-item, .plans-pricing', function () {
            if ($(window).width() <= 768) {
                $('.navbar-toggle').click();
            }
        });
    }

    whyapiplatform() {
        this.router.navigate(['home'], {fragment: 'whyapiplatform'});
    }

    openFeedbackDialog(): void {
        const dialogRef = this.dialog.open(SupportHeaderComponent, {
            width: '550px',
            data: this.feedbackSchema
        });

        dialogRef.afterClosed().subscribe(result => {
        });
    }
}

import {FormControl, Validators} from '@angular/forms';
import {LeftpanelComponent} from '../leftpanel/leftpanel.component';
import {AuthService} from '../user/auth.service';

export interface FeedbackType {
    name: string;
    value: string;
}

@Component({
    selector: 'support-dialog',
    templateUrl: 'support.component.html',
    styleUrls: ['support.component.css'],
})
export class SupportHeaderComponent {

    constructor(
        private confPost: ConfService, public platform: LeftpanelComponent,
        public dialogRef: MatDialogRef<SupportHeaderComponent>,
        @Inject(MAT_DIALOG_DATA) public data: FeedbackData) {
    }

    feedbackSchema = {
        username: '',
        partner: '',
        account: '',
        feedback_type: '',
        feedback_message: '',
        csat_score: 'NA'
    };
    selectedOption: string;
    feedbackOptions: string[] = ['Good', 'Neutral', 'Bad'];
    selectFeedbackTypeControl = new FormControl('', Validators.required);
    feedbacktypes: FeedbackType[] = [
        {name: 'Service Issue', value: 'service'},
        {name: 'Technical Support', value: 'support'},
        {name: 'Partner Account Issue', value: 'account'},
        {name: 'Billing Issue', value: 'billing'},
        {name: 'Plans & Pricing', value: 'pricing'}
    ];

    onNoClick(): void {
        this.dialogRef.close();
    }

    sendSupportRequest(result) {
        this.feedbackSchema.partner = localStorage.getItem('partner');
        this.feedbackSchema.account = localStorage.getItem('account');
        this.feedbackSchema.username = 'experience@apiplatform.io';
        this.confPost.sendFeedback(this.feedbackSchema).subscribe(data => {
            this.platform.openSnackBar('Feedback has been sent successfully', 'Success', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }, error => {
            this.platform.openSnackBar('Error while sending feedback' + (error !== null && error !== undefined && error.error !== null && error.error !== undefined) ? ': ' + error.error.message : '', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }
}
